import {connect} from "react-redux";
import UserStorePage from "./UserStorePage";
import {getResourcePageAction} from "../../../../resources/actions";
import * as ResourceApi from "../../../../api/resources";
import {filterOptionsFactory, sortOptionsFactory} from "../../../../viewOptions/factories";
import {isNoU, SortDirection} from "../../../../utils/DBUtils";
import {createResourcePageItemsSelector, createResourcePageSelector} from "../../../../resources/selectors";
import {number} from "prop-types";
import {compose} from "recompose";
import lifecycle from "recompose/lifecycle";

const getOrdersPageSelector = createResourcePageSelector(ResourceApi.Types.PrizeboothOrder);
const getOrdersPageItemsSelector = createResourcePageItemsSelector(ResourceApi.Types.PrizeboothOrder);

const sortOptions = sortOptionsFactory("created_date");
sortOptions.sorts["created_date"] = SortDirection.Descending;

const mapState = (state) => {
    const storeOrderPage = getOrdersPageSelector(state.resources);
    const items = getOrdersPageItemsSelector(state.resources);

    console.log(storeOrderPage);
    console.log(items);

    const user = state.userManagement.currentUser;
    const isLoading = storeOrderPage.page === 0 || storeOrderPage.fetching === true;
    return {
        prizeboothOrders: items,
        ajaxError: null,
        orderCount: storeOrderPage.count,
        currentPage: storeOrderPage.page,
        totalOrders: storeOrderPage.total,
        pageSize: storeOrderPage.count,
        user,
        isLoading,
    }
};

const mapDispatch = (dispatch) => {
    return {
        fetchStoreOrdersPage: (uid, page) => {
            dispatch(getResourcePageAction(ResourceApi.Types.PrizeboothOrder, 10, page, sortOptions, filterOptionsFactory({
                filters: [
                    {
                        field: "uid",
                        value: uid,
                    }
                ]
            })));
        }
    }
};

const UserStorePageComposed = compose(
    connect(mapState, mapDispatch),
    lifecycle({
        componentDidMount() {
            if (!isNoU(this.props.user) && this.props.currentPage === 0) {
                this.props.fetchStoreOrdersPage(this.props.user.id, 1);
            }
        },
        componentWillReceiveProps(nextProps) {
            if (isNoU(this.props.user) && !isNoU(nextProps.user)
                && this.props.currentPage === 0) {
                this.props.fetchStoreOrdersPage(nextProps.user.id, 1);
            }
        }
    }),
)(UserStorePage);

export default UserStorePageComposed;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/UserStorePageContainer.jsx